import React, { useMemo } from 'react';
import 'react-quill/dist/quill.snow.css';
import { Typography } from '@material-ui/core';
import { format, parseISO } from 'date-fns';
import { sanitizeNewsletterHtml } from 'helpers/newsletter';
import { useStyles } from './styles';

export default ({ title, coverUrl, content, publishedAt }) => {
  const classes = useStyles();
  const html = useMemo(() => sanitizeNewsletterHtml(content), [content]);

  return (
    <article className={classes.root}>
      {coverUrl && <img className={classes.cover} src={coverUrl} alt="" />}
      <Typography className={classes.title} variant="h1">
        {title}
      </Typography>
      {publishedAt && (
        <Typography color="textSecondary" variant="body2">
          {format(parseISO(publishedAt), 'dd/MM/yyyy')}
        </Typography>
      )}
      <div className={`ql-snow ${classes.content}`}>
        <div className="ql-editor" dangerouslySetInnerHTML={{ __html: html }} />
      </div>
    </article>
  );
};
